import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=cee7fe64&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=cee7fe64&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee7fe64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cee7fe64')) {
      api.createRecord('cee7fe64', component.options)
    } else {
      api.reload('cee7fe64', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=cee7fe64&scoped=true&", function () {
      api.rerender('cee7fe64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ym7jp5qO0h0j/JS/comp/Paginate.vue"
export default component.exports